import React, { useEffect } from 'react' 
import { ILayoutBodyProps, ILayoutData } from '@libs/interfaces/layouts' 
import { template } from '@libs/layouts'
import { initArea } from '../../utilities/getWidget'
import LayoutHeader from '../LayoutHeader'
import LayoutContent from '../LayoutContent'
import LayoutFooter from '../LayoutFooter'
import actions from '@/modules/pe-basic-module/data/actions'
import { GET_THEME_ACTION } from '@/modules/pe-basic-module/data/actionTypes'
import { IState, useLayoutStore, useMainStore } from '@/settings/zustand'
import LayoutFooterMenuStrip from './LayoutFooterMenuStrip'
import { Widgets } from '@libs/utilities'

const LayoutBodyLocal = (props: ILayoutBodyProps) => {    
    const layouts: ILayoutData = useMainStore((state: IState) => state.layout )
    useEffect(() => { 
        const headerHeight = document.querySelector(".layout-header")?.clientHeight || 0
        const footerHeight = document.querySelector(".layout-footer-container")?.clientHeight || 0
        // console.log( "footerHeight",  footerHeight )
        // console.log( "headerHeight",  headerHeight )

        useLayoutStore.setState({ 
            headerHeight,
            footerHeight,
        })

        const root = document.documentElement;
        root?.style.setProperty(
            "--header-height",
            headerHeight + "px"
        );
        root?.style.setProperty(
            "--main-height",
            "calc(100dvh - " + ( headerHeight + footerHeight ) + "px)"
        );
        root?.style.setProperty(
            "--footer-height",
            ( footerHeight ) + "px"
        );

        actions( GET_THEME_ACTION, {} )
    }, [ layouts ])
    const def = <div className="layout block w-100">
        {
            !template().header 
                ? 
                null
                : 
                <Widgets areaName="layout-header" data={{}} defArea={<LayoutHeader />} />
        } 
        <LayoutContent />
        <LayoutFooter />
        <LayoutFooterMenuStrip />
    </div> 
    return  <Widgets
        areaName="layout-app" 
        data={{ ...props }}
        defArea={def}
    />
}
 

export default LayoutBodyLocal